export default __webpack_public_path__ + "static/media/bootstrap.22ef163d.png";